import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: false }; // Still render children even with error
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error here if needed
    console.debug('Suppressed error:', error);
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
